import Form from 'react-bootstrap/Form';
import React, {useState} from 'react';


function AddTodo({addTodo}) {
    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");
    const submit = (e)=>{
        e.preventDefault(); 
        if(!title || !desc){
            alert("Title or Description cannot be blank!!");
        }
        else{
            addTodo(title, desc);
            setTitle("");
            setDesc("");
        }
    }
  return (
    <div className="container">
    <Form onSubmit={submit}>
        <h2>Add a Todos</h2><hr/>
      <Form.Group className="my-2" controlId="title">
        <Form.Label>Todo Title</Form.Label>
        <Form.Control type="text" value={title} placeholder="Enter your Todos here" onChange={(e)=>setTitle(e.target.value)}/>
      </Form.Group>
      <Form.Label>Todo Description</Form.Label>
      <Form.Group className="mb-2" controlId="desc">
        <Form.Control type="text" value={desc} placeholder="Describe your Todo" onChange={(e)=>setDesc(e.target.value)}/>
      </Form.Group>
      <button className="btn btn-sm btn-success mt-1 p-2" type="submit">Add Todo</button>
    </Form>
    </div>
  )
}

export default AddTodo
